import qs from 'query-string'

export const getUrlParams = () => qs.parse(window.location.search)

export const stringifyParams = (params = {}) => qs.stringify(params)
